// extracted by mini-css-extract-plugin
export default {"image":"eY-z","loaded":"fY-z"};